<template>
  <div class="pop" v-show="show">
    <div class="box">
      <div id="close" class="close_btn" v-if='closeBtn' @click="close();closeCall()"></div>
      <div class="title">{{title}}</div>
      <div class="wrap">
        {{content}}
        <div style='text-align:center;'>
            <button class="btn" @click="agree">{{agreeBtn}}</button>
            <button class="btn" @click="degree">{{cancelBtn}}</button>
        </div>
        
      </div>
      
    </div>
  </div>
</template>

<script>
  // @ is an alias to /src

  export default {
    name: 'agree',
    data: () => ({
      show: true
    }),
    props: {
      title: {
        default: '提示',
        type: String
      },
      content: {
        default: '',
        type: String
      },
      agreeCall: {
        default: ()=>{},
        type: Function
      },
      degreeCall: {
        default: ()=>{},
        type: Function
      },
      closeCall: {
        default: ()=>{},
        type: Function
      },
      agreeBtn: {
          default: '同意',
          type: String
      },
      cancelBtn: {
          default: '不同意',
          type: String
      },
      closeBtn: {
          default: false,
          type: Boolean
      }
    },
    methods: {
      close () {
        this.show = false
      },
      agree () {
          this.agreeCall()
          this.close()
      },
      degree () {
          this.degreeCall()
          this.close()
      }
    },
    components: {

    },
    mounted() {

    }
  }
</script>

<style scoped>
  .pop {
    position: fixed;
    z-index: 2000;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, .2);
  }

  .box {
    width: 494px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .title {
    height: 34px;
    background: url(../assets/image/confirm_title_bg.jpg) no-repeat;
    color: #fafafa;
    font-size: 15px;
    line-height: 34px;
    padding-left: 11px;
  }

  .wrap {
    background: #fff;
    border: 1px solid #8b8b8b;
    border-top: 0;
    padding: 30px 60px;
    color: #7c7c7c;
    font-weight: bolder;
    font-size: 14px;
  }
  .btn{
    color: #fff;
    font-weight: bolder;
    background: rgb(73, 132, 212);
    padding: 5px 28px;
    cursor: pointer;
    display: inline-block;
    /* width: 96px; */
    zoom: 1;
    border: 0;
    outline: 0;
    margin: 25px 10px 0;
  }
  .close_btn {
        width: 35px;
        height: 35px;
        position: absolute;
        right: 0;
        top: 0;
        background: url(../assets/image/close.png) no-repeat center;
        background-size: 12px;
        cursor: pointer;
  }
  
    /* @media screen and (max-width: 494px) {
        .box {
            width: 95%;
        }
    } */
</style>